import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';

import { useVersionCheck } from '../../hooks/useVersionCheck';

export default function VersionUpdateBanner() {
  const { newVersionAvailable } = useVersionCheck();

  if (!newVersionAvailable) return null;

  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert
        severity="info"
        variant="filled"
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      >
        A new version is available.
      </Alert>
    </Snackbar>
  );
}
